<input hidden [value]="selectedItem()?.title" [attr.id]="controlId()" />

<div
  tabindex="0"
  #dropdownInput
  class="input-base input-dropdown"
  [class]="{
    'input-large': inputSize() === InputSize.large,
    'input-small': inputSize() === InputSize.small,
  }"
  [class.input-error]="error()"
  [class.disabled]="disabled()"
  [class.dropdown-open]="selectedItem()"
  [class.placeholder-selected]="!!selectedItem()"
  (mousedown)="$event.preventDefault()"
  (click)="toggleDropdown(); dropdownInput.focus()"
  (blur)="closeDropdown()"
  [attr.contenteditable]="false">
  {{ selectedItem()?.title || placeholder() || '&nbsp;' }}
  <mat-icon class="input-icon chevron-icon" [svgIcon]="showDropdown() ? 'chevron-up' : 'chevron-down'"></mat-icon>
</div>

<div
  class="dropdown-content"
  [class.match-input-width]="dropdownMatchesInputWidth()"
  [hidden]="!showDropdown()"
  #dropdownContent>
  @if (clearable() && !disabled() && selectedItem()) {
    <div
      class="reset-dropdown-item"
      [class.highlighted]="highlightedIndex() === 0 && selectedItem() !== null && clearable()"
      (mousedown)="$event.preventDefault()"
      (click)="resetInput(); closeDropdown()">
      Reset
    </div>
  }
  @for (item of dropdownItems(); track item.value; let i = $index) {
    @let isItemSelected = item.value === selectedItem()?.value;
    <div
      class="dropdown-item"
      (mousedown)="$event.preventDefault()"
      (click)="itemSelected(item)"
      [class.disabled]="item.disabled"
      [class.highlighted]="adjustedHighlightedIndex() === i"
      [class.selected]="isItemSelected">
      <div class="selected-icon-container">
        @if (isItemSelected) {
          <mat-icon class="selected-icon" [svgIcon]="'check'"></mat-icon>
        }
      </div>
      @if (item.statusPillType !== undefined) {
        <lib-general-status-pill [type]="item.statusPillType">
          {{ item.title }}
        </lib-general-status-pill>
      } @else {
        {{ item.title }}
      }
    </div>
  }
</div>
